import { Directive } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';
import moment from 'moment';
import { WorkingHourUIModel } from '../../../../../models/working-hours';

@Directive({
    selector: '[ngModelGroup] [workingHoursValidator]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: WorkingHoursValidator, multi: true }
    ],
    standalone: false
})
export class WorkingHoursValidator extends BaseValidator {

  constructor() {
    super('WorkingHoursValidatorError');
  }

  protected getValidationResult(control: any) {
    const controls = Object.keys(control.controls).map(x => control.controls[x]);

    if (controls.length > 0 && controls.length % 4 === 0) {
      const formDataMap1: Map<string, any> = new Map<string, any>();

      Object.keys(control.controls).forEach((key) => {
        formDataMap1.set(key, control.value[key]);
      });

      var recordArr: WorkingHourUIModel[] = [];

      var itr: number = 1;
      let workingHour = {} as WorkingHourUIModel;

      formDataMap1.forEach(function (value, index) {
        var _i = index.toString().split('-');
        var i = _i[1];

        if (index.toString().startsWith('day')) {
          workingHour.id = +i;
          workingHour.day = +value;
        } else if (index.toString().startsWith('startTime')) {
          workingHour.startTime = value;
        } else if (index.toString().startsWith('endTime')) {
          workingHour.endTime = value;
        } else if (index.toString().startsWith('removeRow')) {
          workingHour.removeRow = value;
        }

        if (itr % 4 == 0) {
          var abc = { ...workingHour };
          recordArr.push(abc);

          itr = 1;
          workingHour as {};
        }
        else { itr = itr + 1; }
      });

      if (recordArr == null) { return null; }

      recordArr = recordArr.filter(y => y.day && y.removeRow === false);
      var groupedByDay = recordArr.map(function (record) { return record.day }).filter(function (value, index, self) { return self.indexOf(value) === index });
      
      let erroredDays: number[] = [];

      groupedByDay.forEach(async function (day) {
        var dayRecords = recordArr.filter(function (y) { return y.day === day }).orderBy(x => x.startTime);

        if (dayRecords.length > 1) {
          try {
            let hasError = false;
            for (var i = 0; i < dayRecords.length; i++) {              
              var baseStartTime = getDate(dayRecords[i].startTime);
              var baseEndTime = getDate(dayRecords[i].endTime);
  
              for (var j = 0; j < dayRecords.length; j++) {
                if (i === j) { continue; }
                
                var startTime = getDate(dayRecords[j].startTime);
                var endTime = getDate(dayRecords[j].endTime);
  
                if (moment(baseStartTime).isSame(startTime) || moment(baseStartTime).isBetween(startTime, endTime) ||
                  moment(baseEndTime).isSame(endTime) || moment(baseEndTime).isBetween(startTime, endTime)) {                             
                    erroredDays.push(dayRecords[j].day);
                    hasError = true;                  
                    break;
                }
              }
              if (hasError) { break; }
            }            
          }
          catch (e) { console.error(e); }
        }
      });
      
      controls.forEach(x => {
        const hasError = erroredDays.indexOf(x.value) >= 0 && !x.disabled;
        const errors = {};
        if (hasError) {          
          Object.assign(errors, x.errors);          
          Object.assign(errors, {'WorkingHoursValidatorError': ''});
          x.setErrors(errors);
          x.markAsTouched();
        } else {          
          Object.assign(errors, x.errors);
          delete errors['WorkingHoursValidatorError'];
          x.setErrors(errors);
          x.updateValueAndValidity({ onlySelf: true });
        }
      });      
    }

    return null;
  }
}

function getDate(time: string) {
  var today = new Date();
  var _t = time.split(":");
  today.setHours(+_t[0], +_t[1], 0, 0);
  return today;
}
